import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import swal from 'sweetalert';
import { Navigate, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'
import { toast } from 'react-toastify';
import shopping from "assets/images/shopping.png";
import Swal from 'sweetalert2';
import Icon from "@mui/material/Icon";
import { useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";





const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

const CartPage = ({ showCart, showCards, cart, setShowCart, getCartData, setShowSummary, getShowCart, setSummaryData, handleCartBack, getShowPlans }) => {
  const [loading, setLoading] = useState(false);

  const [quantities, setQuantities] = useState({});
  const [cartData, setCartData] = useState(cart);
  const [checkoutButton, setCheckoutButton] = useState()
  const [Disable, setDisable] = useState(false)
  const [retailerWalletBalance, setRetailerWalletBalance] = useState(0);
  const [contactAddress, setContactAddress] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");
  const [contactDetails, setContactDetails] = useState({

  })

  const [startDate, setStartDate] = useState(new Date());
  const [value, setValue] = useState("")
  const [collectorName1, setCollectorName1] = useState('');
  const [collectorName2, setCollectorName2] = useState('');
  const [collectorEmail, setCollectorEmail] = useState('');
  const [comments, setComments] = useState('');
  // const[selectOption,setSelectOption]=useState("false")


  const filterPassedTime = (time) => {
    const selectedDate = new Date(time);
    const now = new Date();

    // Allow times only if the selected date is today or in the future
    return selectedDate.getTime() >= now.getTime();
  };

















  useEffect(() => {
    const initialQuantities = {};
    cart?.cart_array?.forEach(item => {
      initialQuantities[item?.product_id] = item?.product_quantity || 0;
      setCheckoutButton(item?.product_quantity)
    });
    setQuantities(initialQuantities);
    //  handleGoToCart();
  }, [cart]);

  const handleBack = () => {
    handleCartBack(false)
    getShowPlans()
  }

  const handleUpdateCart = async (planId, newQuantity) => {
    const cartData = {
      retailer_id: sessionStorage.getItem('retailerID'),
      product_id: planId,
      quantity: newQuantity,
      cart_value: 1,
    };

    console.log('rid', cartData);
    try {
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}product-stock/add-to-cart`, cartData, { headers: header });
      setCheckoutButton(response.data.data.cart_count_total)
      console.log("response in hndle cart", response.data.data.cart_count_total)
      if (response.data.data.cart_count_total === 0) {
        // setCartData("")
        // showCards(false)
        // showCart(false)
      }


      handleGoToCart();
    } catch (error) {
      console.error("Error updating cart:", error);
      swal("", error?.response.data.message, "warning");



    }
  };

  const incrementQty = (planId) => {
    console.log("planId", planId)

    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty < 30) {
        const newQty = currentQty + 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const decrementQty = (planId) => {
    console.log("planId", planId)

    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = currentQty - 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const removeItem = async (planId) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = 0;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
        product_id: planId,
        quantity: 0,
        cart_value: 1,
      };

      console.log("formdata.retailerid", formData.retailer_id)
      const response = await axios.post(`${SERVER_URL}product-stock/add-to-cart`, formData, { headers: header });
      if (response.status === 200) {
        console.log("cart count", response.data.data.cart_count_total)
        if (response.data.data.cart_count_total === 0) {
          // setCartData("")
          // showCards(false)
          // showCart(false)
        }
      }

      handleGoToCart();
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  const handleGoToCart = async () => {
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
      };
      const response = await axios.post(`${SERVER_URL}product-stock/cart`, formData, { headers: header });
      if (response.status === 200) {
        setCartData(response.data?.data);
        setRetailerWalletBalance(response.data?.data?.retailer_wallet_balance);
        // getCartData(response.data?.data);


      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };



  const handleCheckout = async () => {
    let selectOption = "false"
    if (!selectedOption) {
      swal("", "Please select a Stock handover option to continue.", "warning");
      return;
    } else if (selectedOption === "collection") {
      selectOption = "true"

      if (collectorEmail) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        if (!emailPattern.test(collectorEmail)) {
          swal({
            text: "Please enter a valid email address.",
            icon: "warning",
            button: "OK",
          });
          return;
        }
      }
      
      let missingFields = [];
      if (!collectorName1) missingFields.push("First Name");
      if (!collectorName2) missingFields.push("Last Name");
      if (!collectorEmail) missingFields.push("Email");
      // setSelectOption("true")
      if (missingFields.length > 0) {
        swal("", `Please provide: ${missingFields.join(", ")}`, "warning");
        return;
      }
    }


    try {
      setLoading(true);

      const retailerId = sessionStorage.getItem('retailerID')
      const formData = {
        retailer_id: retailerId,
        startDate,
        collectorName1,
        collectorName2,
        collectorEmail,
        comments,
        select_option: selectOption
      };


      const header = await getApiHeader();
      const res = await axios.post(
        `${SERVER_URL}product-stock/checkout`,
        { formData },
        { headers: header }
      );
      if (res.status === 200) {
        console.log("response in data ", res.data.data.data)
        setLoading(false);
        setShowSummary(true)
        getShowCart(false)
        setSummaryData(res.data?.data.data)
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      setLoading(false);
      swal({
        title: "",
        text: error?.response?.data?.message ? error?.response?.data?.message : "An error occured",
        icon: "error",
        button: "Close"
      });
    }
  };
  const handleRemoveProduct = async (plan_id) => {
    removeItem(plan_id);
  };



  const handleRadioChange = (value) => {
    setSelectedOption((prev) => (prev === value ? "" : value));
    setContactAddress(value === "collection" && selectedOption !== "collection");
  };










  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      {cartData?.cart_array?.length > 0 ?
        <div className="container cart cart-section">
          <h4 style={{ fontWeight: 'bold' }} className="text-center mb-4">Confirm Order</h4>
          {cartData?.cart_array?.length > 0 ? (
            <div className="oc-table">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th> Sl.no</th>
                      <th>Product</th>
                      <th>Qty</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartData?.cart_array?.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td> {index + 1}</td>
                          <td>
                            <img
                              src={item.image}
                              alt={item?.offerName || "Product"}
                              className="img-fluid"
                              style={{ width: '100px' }}
                            />
                            <p style={{ textAlign: "center", color: "black" }}>{item?.product_name}</p>
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => decrementQty(item?.product_id)}
                            // disabled={false}
                            >
                              -
                            </button>

                            <span className="mx-2">{quantities[item?.product_id] || item?.product_quantity || 0}</span>

                            <button
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => incrementQty(item?.product_id)}
                              // disabled={false}
                              disabled={quantities[item?.product_id] >= item.stock_quantity}

                            >
                              +
                            </button>
                          </td>
                          <td>
                            <button className="btn btn-danger btn-remove" onClick={() => handleRemoveProduct(item?.product_id)}> Remove <i class="fa fa-times-circle"></i> </button>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="7">
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div></div>
          ) : (
            <p className="text-center">Your cart is empty.</p>
          )}

          <div className="row mt-4">
            <div className="col-md-6 address-box">
              <h5>Stock Handover <span style={{ color: "red" }}>  * </span></h5>
              <input
                type="radio"
                id="deliveryRequired"
                name="stock_handover"
                value="delivery"
                checked={selectedOption === "delivery"}
                onChange={() => handleRadioChange("delivery")}
                style={{ width: "17px", height: "15px" }}
              />
              <span style={{ marginLeft: "10px", fontSize: "17px" }}>Delivery Address</span>
              <p>{cartData?.address}</p>
              <input
                type="radio"
                id="collection"
                name="stock_handover"
                value="collection"
                checked={selectedOption === "collection"}
                onChange={() => handleRadioChange("collection")}
                style={{ width: "17px", height: "15px" }}
              />
              <span style={{ marginLeft: "6px", marginBottom: "10px", fontSize: "17px" }}> Collection from Telsim Office</span>
              {contactAddress && (

                <form>
                  <div class="form-container">
                    <div class="form-group">
                      <label htmlFor="collectionDate" style={{ fontSize: "14px" }}>
                        Collection Date  <span class="required">*</span>
                      </label>


                      <div className="input-container stock-collection-date-picker">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            const formattedDate = date ? date.toISOString().split('T')[0] : '';
                            setStartDate(formattedDate);
                          }}
                          autoComplete="off"
                          showYearDropdown
                          showMonthDropdown
                          scrollableYearDropdown
                          className="form-input"
                          minDate={new Date()}
                        />
                      </div>



                    </div>

                    <div class="form-group">
                      <label style={{ fontSize: "14px" }}>Who will collect the stock? <span class="required">*</span></label>
                      <div class="name-inputs">
                        <input type="text" class="form-input half-width" id="collectorName1" name="collectorName1" placeholder="First Name" required value={collectorName1}
                          onChange={(e) => setCollectorName1(e.target.value)} style={{ outline: "none", }} />
                        <input type="text" class="form-input half-width" id="collectorName2" name="collectorName2" placeholder="Last Name" value={collectorName2} style={{ outline: "none", }}
                          onChange={(e) => setCollectorName2(e.target.value)} />
                      </div>
                    </div>

                    <div class="form-group">
                      <label style={{ fontSize: "14px" }}>Email Address of the person collecting stock <span class="required">*</span></label>
                      <div class="input-container">
                        <input type="email" id="collectorEmail" name="collectorEmail" placeholder="Enter email address" required class="form-input" value={collectorEmail}
                          onChange={(e) => setCollectorEmail(e.target.value)} style={{ outline: "none", }} />
                      </div>
                    </div>



                  </div>
                </form>


              )}
            </div>


            <div className="form-group  col-lg-6">
              <label>Comments :</label>
              <div className="input-container">
                <textarea className="form-input" name="comments" placeholder="Add any additional comments" value={comments}
                  onChange={(e) => setComments(e.target.value)} style={{ outline: "none", }}></textarea>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <label for="html"></label>
              </div>
            </div>

            {checkoutButton > 0 ?
              <div className="d-flex justify-content-end mt-3">
                <button className="checkout checkout-btn" onClick={handleCheckout}>Submit Order <i class="fa fa-caret-right"></i></button>
              </div>
              : ""
            }
          </div>

          <button style={{ margin: "10px", backgroundColor: "#e20e75", borderRadius: "5px", border: "none", color: "white", padding: "3px", fontSize: "19px", width: "134px" }} onClick={handleBack} > Back</button>

        </div>
        :
        <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontFamily: '-moz-initial' }} className="container cart cart-section">
          <h4 className="text-center mb-4" style={{ fontWeight: 'bold' }}>Cart is empty</h4>
          <img src={shopping} alt="shopping" style={{ width: '150px', height: "150px" }} />
          {/* <br></br> */}
          <p style={{ fontSize: 18, textAlign: 'center', lineHeight: 1.5, color: 'black' }}> ‘Must add items to the cart before you proceed to check out.’</p>
          <button style={{ margin: "10px", backgroundColor: "#e20e75", borderRadius: "5px", border: "none", color: "white", padding: "3px", fontSize: "19px", width: "159px", fontWeight: 'bolder' }} onClick={handleBack} >
            {'Go to Products'}
            <Icon style={{ paddingTop: '2.6%' }}>arrow_forward</Icon>
          </button>
        </div>
      }
    </>
  );
};

export default CartPage;
